import { render, staticRenderFns } from "./OrderColumn.vue?vue&type=template&id=1d7ac49f&scoped=true&"
import script from "./OrderColumn.vue?vue&type=script&lang=js&"
export * from "./OrderColumn.vue?vue&type=script&lang=js&"
import style0 from "./OrderColumn.vue?vue&type=style&index=0&id=1d7ac49f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7ac49f",
  null
  
)

export default component.exports